module.exports = __webpack_public_path__ + "img/next.cc13b3fe.svg";